<script setup lang="ts">
import { Check } from "@lucide/vue";

defineProps<{
  /** Defaults to the upload, column matching and import steps every import goes through. */
  steps?: string[];
  /** Index of the step the user is on. */
  current: number;
}>();
</script>

<template>
  <ol class="tw:flex tw:flex-col tw:items-start tw:gap-2 tw:list-none tw:p-0 tw:m-0 tw:text-sm tw:sm:flex-row tw:sm:items-center tw:sm:gap-3">
    <template v-for="(step, index) in steps ?? [$t('Upload'), $t('Match columns'), $t('Import')]" :key="step">
      <li v-if="index > 0" aria-hidden="true" class="tw:ml-3 tw:h-3 tw:w-px tw:bg-zinc-300 tw:sm:ml-0 tw:sm:h-px tw:sm:w-10"></li>
      <li
        class="tw:flex tw:items-center tw:gap-2"
        :class="index <= current ? 'tw:font-medium' : 'tw:text-zinc-500'"
        :aria-current="index === current ? 'step' : undefined"
      >
        <span v-if="index < current" class="tw:flex tw:size-6 tw:items-center tw:justify-center tw:rounded-full tw:bg-green-100 tw:text-green-700">
          <Check class="tw:size-3.5" />
        </span>
        <span v-else-if="index === current" class="tw:flex tw:size-6 tw:items-center tw:justify-center tw:rounded-full tw:bg-zinc-900 tw:text-xs tw:text-white">
          {{ index + 1 }}
        </span>
        <span v-else class="tw:flex tw:size-6 tw:items-center tw:justify-center tw:rounded-full tw:border tw:border-zinc-300 tw:text-xs">
          {{ index + 1 }}
        </span>
        {{ step }}
      </li>
    </template>
  </ol>
</template>
